var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPrivate5G(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50,26.75A7.258,7.258,0,0,1,57.25,34h1.5a8.75,8.75,0,0,0-17.5,0V46a8.75,8.75,0,0,0,17.5,0V39.25H50v1.5h7.25V46a7.25,7.25,0,0,1-14.5,0V34A7.258,7.258,0,0,1,50,26.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.25,38.75H30A7.25,7.25,0,1,1,22.75,46h-1.5A8.75,8.75,0,1,0,30,37.25H24.75v-8.5H38v-1.5H23.25Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25,14V52.82861c0,4.93409,2.918,9.61573,7.09766,11.38477L39.709,70.69092a.74869.74869,0,0,0,.583,0l15.30469-6.478c4.17773-1.76855,7.0957-6.44971,7.0957-11.38428V14a.75019.75019,0,0,0-.75-.75H52v1.5h9.19238V52.82861c0,4.28028-2.59863,8.48731-6.17968,10.00293L39.999,69.186,24.93066,62.832C21.34961,61.31543,18.75,57.1084,18.75,52.82861V14.75H28v-1.5H18A.7502.7502,0,0,0,17.25,14Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.25,13.25H38.67432a3.75,3.75,0,1,0,0,1.5H41.25v2h1.5v-2h2.5v2h1.5v-2H48v-1.5H45.25ZM35,16.25A2.25,2.25,0,1,1,37.25,14,2.25278,2.25278,0,0,1,35,16.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrivate5G);
export default __webpack_public_path__ + "static/media/icon_private_5g.d7df1471c8f35001adbb200fab9d56dd.svg";
export { ForwardRef as ReactComponent };